module.exports = __webpack_public_path__ + "img/header-1.ed3861ee.png";